import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const WHOLESALE_ORDER_SUCCESS = 'WHOLESALE_ORDER_SUCCESS';
export const WHOLESALE_ORDER_LOADING = 'WHOLESALE_ORDER_LOADING';

const { wholesaleOrder: { getWholesaleOrder } } = apiUrls;


export const getOrderDetails = ({ fromdate, todate }) => async (dispatch) => {
  try {
    const { url } = getWholesaleOrder
    const requestData = {
        ...getWholesaleOrder,
        url: url.replace('{{fromDate}}', fromdate).replace('{{toDate}}', todate)
    };
    const data = await REQUEST(requestData);
    dispatch({
      type: WHOLESALE_ORDER_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: WHOLESALE_ORDER_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: WHOLESALE_ORDER_LOADING,
    isLoading
  })
}
